<div class="container mx-auto p-6" *transloco="let t">
  @if (loading()) {
    <app-loading />
  } @else if (prerequisiteInfo()) {
    <p-card>
      <app-no-data
        [icon]="prerequisiteInfo()!.icon"
        [label]="prerequisiteInfo()!.titleKey"
        [description]="prerequisiteInfo()!.messageKey"
      />
    </p-card>
  } @else if (shouldShowContent()) {
    <p-card>
      <h1 class="text-2xl font-bold mb-6">
        {{ t('project.steps.rfd.agenda.title') }}
      </h1>
      <app-demonstration-agenda-table
        [items]="agendaItems()"
        [locked]="isCurrentStepLocked()"
        [lockedTooltip]="stepLockedTooltip()"
        [expandedIds]="expandedAgendaItemIds()"
        (durationChange)="onDurationChange($event.item, $event.duration)"
        (moveUp)="moveAgendaItemUp($event)"
        (moveDown)="moveAgendaItemDown($event)"
        (expansionChange)="toggleAgendaItemExpansion($event)"
      />

      @if (hasChanges()) {
        <div class="flex justify-end mt-4">
          <app-project-step-save-button
            [loading]="saving()"
            [disabled]="saving() || isCurrentStepLocked()"
            (clicked)="onSave()"
          />
        </div>
      }
    </p-card>
  }
</div>
